import React, { useState, useEffect } from 'react';
import '../styles/countdown-display.css';
import { cx, useRuntimeCss } from '../shared/styles/runtimeCss';

const COUNTDOWN_UNITS = [
  { key: 'days', label: 'дни' },
  { key: 'hours', label: 'часове' },
  { key: 'minutes', label: 'минути' },
  { key: 'seconds', label: 'секунди' },
];

const EMPTY_COUNTDOWN = Object.freeze({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  expired: false,
});

const EXPIRED_COUNTDOWN = Object.freeze({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  expired: true,
});

const getThemeVariables = (theme) => ({
  '--countdown-primary': theme?.colors?.primary || '#4e7c7f',
  '--countdown-background': theme?.colors?.background || '#ffffff',
  '--countdown-text': theme?.colors?.text || '#1c1c1a',
  '--countdown-heading-font': theme?.fonts?.heading || 'inherit',
  '--countdown-radius': theme?.borderRadius?.medium || '16px',
  '--countdown-shadow': theme?.shadows?.small || '0 4px 8px rgba(0, 0, 0, 0.1)',
});

const calculateCountdown = (weddingDate) => {
  const targetTimestamp = new Date(weddingDate).getTime();
  const now = Date.now();
  const difference = targetTimestamp - now;

  if (difference <= 0) {
    return EXPIRED_COUNTDOWN;
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((difference % (1000 * 60)) / 1000),
    expired: false,
  };
};

const CountdownGrid = ({ items, placeholder = false }) => (
  <div
    className={`countdown-display__grid${
      placeholder ? ' countdown-display__grid--placeholder' : ''
    }`}
  >
    {items.map(({ label, value }) => (
      <div
        key={label}
        className={`countdown-display__cell${
          placeholder ? ' countdown-display__cell--placeholder' : ''
        }`}
      >
        <div className="countdown-display__value">{value}</div>
        <div className="countdown-display__label">{label}</div>
      </div>
    ))}
  </div>
);

const CountdownDisplay = ({ weddingDate, expiredMessage, theme }) => {
  const css = useRuntimeCss();
  const [timeLeft, setTimeLeft] = useState({
    ...EMPTY_COUNTDOWN,
  });

  useEffect(() => {
    if (!weddingDate) return;

    const updateCountdown = () => {
      setTimeLeft(calculateCountdown(weddingDate));
    };

    updateCountdown();

    const timer = setInterval(() => {
      updateCountdown();
    }, 1000);

    return () => clearInterval(timer);
  }, [weddingDate]);

  const themeVariables = getThemeVariables(theme);

  if (!weddingDate) {
    const placeholderItems = COUNTDOWN_UNITS.map(({ label }) => ({ label, value: 0 }));

    return (
      <div className={cx('countdown-display', css(themeVariables))}>
        <CountdownGrid items={placeholderItems} placeholder />
      </div>
    );
  }

  if (timeLeft.expired) {
    return (
      <div className={cx('countdown-display', css(themeVariables))}>
        <div className="countdown-display__expired">
          {expiredMessage || 'Денят настъпи!'}
        </div>
      </div>
    );
  }

  const countdownItems = COUNTDOWN_UNITS.map(({ key, label }) => ({
    label,
    value: timeLeft[key],
  }));

  return (
    <div className={cx('countdown-display', css(themeVariables))}>
      <CountdownGrid items={countdownItems} />
    </div>
  );
};

export default CountdownDisplay;
